(() => {
  const selectors = ['#store_map .gm-style', '#store_map iframe', '.gm-style'];
  const loadTimeout = 12000;

  const hasRenderedMap = (shell) => selectors.some((selector) => shell.querySelector(selector));

  const markLoaded = (shell) => {
    shell.classList.add('is-loaded');
    shell.classList.remove('is-error');
    shell.setAttribute('data-store-locator-loaded', 'true');

    const status = shell.querySelector('[data-store-locator-status]');

    if (status) {
      status.hidden = true;
    }
  };

  const markFailed = (shell) => {
    shell.classList.add('is-error');
    shell.setAttribute('data-store-locator-loaded', 'false');

    const status = shell.querySelector('[data-store-locator-status]');

    if (status) {
      status.hidden = false;
    }
  };

  document.querySelectorAll('[data-store-locator-shell]').forEach((shell) => {
    if (hasRenderedMap(shell)) {
      markLoaded(shell);
      return;
    }

    const observer = new MutationObserver(() => {
      if (!hasRenderedMap(shell)) {
        return;
      }

      markLoaded(shell);
      observer.disconnect();
    });

    const timeout = window.setTimeout(() => {
      if (!hasRenderedMap(shell)) {
        markFailed(shell);
      }
    }, loadTimeout);

    observer.observe(shell, {
      childList: true,
      subtree: true
    });

    window.addEventListener('load', () => {
      if (hasRenderedMap(shell)) {
        window.clearTimeout(timeout);
        markLoaded(shell);
        observer.disconnect();
      }
    }, { once: true });
  });
})();
